var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 72",
    width: 100,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "creditcardsBanner1-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 29,
    id: "img1",
    href: "data:image/png;base64,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"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: transparent } \n\t\t.s2 { fill: #e8f5fe } \n\t\t.s3 { fill: #002f6c } \n\t\t.s4 { fill: #ffb81c } \n\t\t.s5 { fill: #0091da } \n\t\t.s6 { fill: #005eb8 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hp--new-offers--"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-desktop---3-cards"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m-151-3273h1440v4063h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "s1",
    d: "m-151-53h1440v176h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_just_browsing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s2",
    d: "m96.5 33.5l-52.2-52.2c-1.7-1.7-4.5-1.7-6.2 0l-30.7 30.7c-1.7 1.7-1.7 4.5 0 6.2l52.3 52.2c1.7 1.7 4.4 1.7 6.1 0l30.7-30.7c1.7-1.7 1.7-4.5 0-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s3",
    d: "m78.3 1.7h-74c-2.4 0-4.3 2-4.3 4.4v43.5c0 2.4 1.9 4.3 4.3 4.3h74c2.4 0 4.3-1.9 4.3-4.3v-43.5c0-2.4-1.9-4.4-4.3-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s4",
    d: "m87 10.4h-74c-2.4 0-4.3 2-4.3 4.4v43.5c0 2.4 1.9 4.3 4.3 4.3h74c2.4 0 4.3-1.9 4.3-4.3v-43.5c0-2.4-1.9-4.4-4.3-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s5",
    d: "m95.7 19.1h-74c-2.4 0-4.3 2-4.3 4.4v43.5c0 2.4 1.9 4.3 4.3 4.3h74c2.4 0 4.3-1.9 4.3-4.3v-43.5c0-2.4-1.9-4.4-4.3-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s6",
    d: "m95.7 71.3h-60.9l52.2-52.2h8.7c1.1 0 2.2 0.5 3 1.3 0.8 0.8 1.3 1.9 1.3 3.1v43.5c0 1.1-0.5 2.2-1.3 3-0.8 0.8-1.9 1.3-3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s6",
    d: "m65.2 60.4h-39.1v4.4h39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s3",
    d: "m65.2 64.8h-23.9l4.4-4.4h19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s0",
    d: "m30.8 25.6q-0.2 0.1-0.4 0.2-0.1 0.1-0.1 0.3v3.2h8.5l-3.9-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s0",
    d: "m39.1 30.3q0-0.1 0-0.2 0-0.1-0.1-0.1-0.1-0.1-0.2-0.1 0-0.1-0.1-0.1h-3.3v8.6l3.7-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s0",
    d: "m34.5 38.7q0.2 0 0.3-0.1 0.1-0.2 0.1-0.4v-3.2h-8.5l3.9 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s0",
    d: "m26.1 34q0 0.1 0 0.2 0.1 0.1 0.1 0.2 0.1 0 0.2 0.1 0.1 0 0.1 0h3.3v-8.5l-3.7 3.8v4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s4",
    d: "m35.9 47.4h-8.7c-0.6 0-1.1 0.5-1.1 1.1v4.3c0 0.6 0.5 1.1 1.1 1.1h8.7c0.6 0 1.1-0.5 1.1-1.1v-4.3c0-0.6-0.5-1.1-1.1-1.1z"
  })))), /*#__PURE__*/React.createElement("use", {
    id: "Visa-Logo-PNG-Image (1)",
    href: "#img1",
    transform: "matrix(.24,0,0,.24,74,58)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0e157736d81b1245f580a05ec1b2a2e5.svg";
export { ForwardRef as ReactComponent };